import React, { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { Element } from 'src/components';
import { TruncateText } from 'src/modules/shared/components/Truncate';
interface IProps {
    description: string;
    className?: string;
    objEllipsis?: any;
    hasTruncate?: boolean;
}

export function ContentDescription({
    description,
    className = '',
    objEllipsis,
    hasTruncate = true,
}: IProps) {
    if (!description) {
        return null;
    }

    return (
        <Element
            renderAs="p"
            className={twMerge(
                // 'description',
                'text-[14px] leading-[20px] text-[#6c757d]',
                className
            )}
        >
            {hasTruncate ? (
                <TruncateText content={description} objEllipsis={objEllipsis} />
            ) : (
                <>{description}</>
            )}
        </Element>
    );
}

export default memo(ContentDescription);
